(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsPostTypes(
            module.exports,
            require('./colors.js')
        );

    } else {
        RivalIQ.module('enums');

        enumsPostTypes(
            RivalIQ.enums,
            RivalIQ.enums.colors
        );
    }

    function enumsPostTypes(exports, colors) {

        // NOTE these id values must match those stored in the media_type database table

        exports.postTypes = {
            gif: {
                id: 1,
                className: 'gif-plays',
                format: 'GIF',
                color: colors.green
            },
            link: {
                id: 2,
                className: 'link-clicks',
                format: 'Link',
                color: colors.blue
            },
            photo: {
                id: 3,
                className: 'photo-views',
                format: 'Photo',
                color: colors.orange
            },
            status: {
                id: 4,
                className: 'status-update',
                format: 'Status Update',
                color: colors.lightBlue
            },
            video: {
                id: 5,
                className: 'video-plays',
                format: 'Video',
                color: colors.lightYellow
            },
            carousel: {
                id: 6,
                className: 'carousel-views',
                format: 'Carousel'
            },
            // id 7 is defunct
            article: {
                id: 8,
                className: 'article',
                format: 'Article',
                color: colors.royalBlue
            },
            note: {
                id: 9,
                className: 'note-post',
                format: 'Note'
            },
            event: {
                id: 10,
                className: 'event-post',
                format: 'Event'
            },
            // BUGBUG where do we use image instead of photo? research...
            image: {
                id: 11,
                className: 'photo-views',
                format: 'Image',
                color: colors.orange
            },
            poll: {
                id: 12,
                className: 'poll',
                format: 'Poll'
            },
            quote: {
                id: 13,
                className: 'quote',
                format: 'Quote'
            },
            reel: {
                id: 14,
                className: 'reel',
                format: 'Reel'
            }
        };
    }
})();
